import { call, put, takeLatest } from 'redux-saga/effects';

import { hasUnits } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(hasUnits, { unit: action.payload });
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* hasUnitsSaga() {
  yield takeLatest(actionTypes.HAS_UNITS_REQUEST_START, getData);
}
